const React = require('react');
const PropTypes = require('prop-types');

const { connect } = require('react-redux');


const { formatText, getLanguage } = require('core/i18n').i18n;
const DateHelper = require('utilities/dateHelper');
const { formatAmountObject, getPlainAmountObject } = require('utilities/currencyHelper');
const { getDeferralMonthsText, isLavandaCard, getKeyParamCard, getTinAndTaeValues } = require('utilities/lavandaHelper');

const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
const { LoadingSection } = require('commonsComponents/loadingSection');
const { QuotaSelector } = require('./accountPaymentPurchaseDeferralQuotaSelector');


const { getQuotaAmount, getQuotaData, setDeferralOption } = require('actions/accountPaymentPurchaseDeferral');

const { LAVANDA } = require('constants/flagBasedFeatures');

const TRANSLATION_KEY_PREFIX = 'accountPaymentPurchaseDeferralStep-';
const PAY_LATER = 'pago_facil_paga_despues';
const NOMINAL = 'nominal';
const TAE = 'tae';
const TIN = 'tin';

class FinancialDataPurchaseDeferral extends React.PureComponent {
    constructor(props){
        super(props)

        this.buildInformation = this.buildInformation.bind(this)
        this.buildQuotaSelector = this.buildQuotaSelector.bind(this)
        this.onHandleSetQuota = this.onHandleSetQuota.bind(this)
    }

    componentWillMount(){
        const {
            getQuotaAmount,
            getQuotaData,
            immAccount,
            immCard,
            immLavanda,
            immMovement,
            lavandaEnabled,
        } = this.props;
        const showLavandaFlow = lavandaEnabled && immLavanda.get('success') && isLavandaCard(immCard.get('product'), immLavanda.get('cards'));
        showLavandaFlow ? getQuotaAmount(immCard, immMovement, immAccount, 3) : getQuotaData(immCard, immMovement, immAccount, 2);
    }

    onHandleSetQuota(quota){
        const { getQuotaData, immCard, immMovement, immAccount } = this.props
        getQuotaData(immCard, immMovement, immAccount, quota)
    }

    buildQuotaSelector(isLavandaFlow){
        const {
            chosenDeferral,
            immMovement,
            lavandaEnabled,
            setDeferralOption,
            step,
            threeMonthQuotaAmount,
            parameters,
            immCard,
        } = this.props;
        const maxQuotas = 36
        const minQuotas = 2
        const currentQuota = step.getIn(['financingData', 'currentQuota'], 2)
        const interests = step.getIn(['financingData', 'interests'])
        const quotaMonthly = step.getIn(['financingData', 'quotaMonthly'])
        const installmentList  = step.getIn(['financingData', 'installmentList'])
        const totalAmountOwed = step.getIn(['financingData', 'totalAmount']);
        const financedPurchasedAmount = immMovement.get('balance');
        const keyParam = getKeyParamCard(immCard);
        const interestTae = parameters && parameters.getIn([keyParam, PAY_LATER, TAE]);
        const interestTin = parameters && parameters.getIn([keyParam, PAY_LATER , TIN]);
        return (
            <QuotaSelector
                chosenDeferral={chosenDeferral}
                immCard={immCard}
                fetching={this.props.fetching}
                financedPurchasedAmount={financedPurchasedAmount}
                isLavandaCard={isLavandaFlow}
                lavandaEnabled={lavandaEnabled}
                minQuotas={minQuotas}
                maxQuotas={maxQuotas}
                currentQuota={currentQuota}
                interests={interests}
                quotaMonthly={quotaMonthly}
                installmentList={installmentList}
                setQuotaQuantity={this.onHandleSetQuota}
                loading={this.props.loading}
                setDeferralOption={setDeferralOption}
                threeMonthQuotaAmount={threeMonthQuotaAmount}
                totalAmountOwed={totalAmountOwed}
                tin={interestTin}
                tae={interestTae}
            />
        )
    }

    buildDeferralOptions(isLavandaFlow){
        return (
            <OKInformativeList columns={1}>
                <OKInformativeListItem
                    title="lavanda-lavanda_deferralOptions"
                >
                    {this.buildQuotaSelector(isLavandaFlow)}
                </OKInformativeListItem>
            </OKInformativeList>
        );
    }

    buildInformation(isLavandaFlow){
        const {
            chosenDeferral,
            immCard,
            immMovement,
            parameters,
            step,
        } = this.props;
        const financedPurchasedAmount = immMovement.get('balance');
        const operationDate = DateHelper.formatDate(immMovement.get('date'));
        const operationTime = immMovement.get('time') && DateHelper.formatDate(immMovement.get('time'));
        const operationDescription = immMovement.get('description')
        const plainAmountObject = getPlainAmountObject(financedPurchasedAmount);
        const isPack = immCard.get('isDiamond') || immCard.get('isPremium')
        const taeExample = !isLavandaFlow ? formatText(isPack ? 'cardPayLater-taePremiumDiamondExample' : `${TRANSLATION_KEY_PREFIX}paymentDeferralTaeTooltip`) : null;
        const keyParam = getKeyParamCard(immCard);
        const interestMn = parameters && parameters.getIn([keyParam, PAY_LATER, NOMINAL]);
        const language = getLanguage();
        const currentQuota = step.getIn(['financingData', 'currentQuota']);
        const deferralMonthsText = getDeferralMonthsText(currentQuota);
        const { [TAE]: interestTae, [TIN]: interestTin } = getTinAndTaeValues(isLavandaFlow, chosenDeferral, immCard, parameters);
        return (
            <OKInformativeList columns={2}>
                <OKInformativeListItem
                    title={TRANSLATION_KEY_PREFIX + 'financedPurchasedAmount'}
                >
                    <OneLineSymbolAmount
                        positiveAmount
                        className="card-payment-purchase-deferral-step__amount"
                        amountObject={plainAmountObject}
                        language={language}
                        amountObjectFormatted={formatAmountObject(plainAmountObject, true)} />
                </OKInformativeListItem>
                <OKInformativeListItem
                    title={TRANSLATION_KEY_PREFIX + 'tae'}
                    bodyText={interestTae}
                    icon={taeExample ? "icon-pregunta" : ''}
                    information={taeExample}
                    isDarkTitle={isLavandaFlow}
                />
                <OKInformativeListItem
                    bodyWordBreak={false}
                    title={TRANSLATION_KEY_PREFIX + 'description'}
                    bodyText={operationDescription}
                />
                <OKInformativeListItem
                    title={TRANSLATION_KEY_PREFIX + 'tin'}
                    bodyText={interestTin}
                />
                <OKInformativeListItem
                    title={TRANSLATION_KEY_PREFIX + 'operationDate'}
                    bodyText={operationDate}
                />
                {!isLavandaFlow &&
                    <OKInformativeListItem
                        title={TRANSLATION_KEY_PREFIX + 'monthlyNominal'}
                        bodyText={interestMn}
                    />
                }
                {!isLavandaFlow && operationTime &&
                    <OKInformativeListItem
                        title={TRANSLATION_KEY_PREFIX + 'operationTime'}
                        bodyText={operationTime}
                    />
                }
                {isLavandaFlow &&
                    <OKInformativeListItem
                        title="lavanda-lavanda_purchaseNature"
                        bodyText="lavanda-lavanda_paymentDeferral"
                    />
                }
                {isLavandaFlow &&
                    <OKInformativeListItem
                        title="lavanda-lavanda_deferralDuration"
                        bodyText={deferralMonthsText}
                    />
                }
            </OKInformativeList>
        )
    }

    render() {
        const { isFetchingSpecificQuota, immCard, immLavanda, lavandaEnabled } = this.props;
        const isLavandaSuccess = lavandaEnabled && immLavanda.get('success');
        let content = <LoadingSection />;

        if (!lavandaEnabled || (isLavandaSuccess && !isFetchingSpecificQuota)){
            const isLavandaFlow = lavandaEnabled && isLavandaCard(immCard.get('product'), immLavanda.get('cards')); 

            content = (
                <div className="accounts-payment-purchase-deferral__step accounts-payment-purchase-deferral__financial-step">
                    <div className="accounts-payment-purchase-deferral__step__div-title">
                        <h3 className="accounts-payment-purchase-deferral__step__div-title__title">{formatText("accountPaymentDeferral-financialTitle")}</h3>
                    </div>
                    <div className="accounts-payment-purchase-deferral__step__cards-content">
                        {this.buildInformation(isLavandaFlow)}
                        {isLavandaFlow && this.buildDeferralOptions(isLavandaFlow)}
                        {!isLavandaFlow && this.buildQuotaSelector(isLavandaFlow)}
                    </div>
                </div>
            )
        }

        return content;
    }
}

FinancialDataPurchaseDeferral.propTypes = {
    chosenDeferral: PropTypes.string,
    fetching: PropTypes.bool,
    immMovement: PropTypes.object.isRequired,
    immAccount: PropTypes.object.isRequired,
    immAccountPaymentPurchaseDeferral: PropTypes.object.isRequired,
    immCard: PropTypes.object.isRequired,
    immLavanda: PropTypes.object.isRequired,
    isFetchingSpecificQuota: PropTypes.bool,
    lavandaEnabled: PropTypes.bool,
    getQuotaAmount: PropTypes.func,
    getQuotaData: PropTypes.func,
    setDeferralOption: PropTypes.func,
    step: PropTypes.object,
    loading: PropTypes.bool,
    parameters: PropTypes.object.isRequired,
    threeMonthQuotaAmount: PropTypes.object,
};

module.exports.constructor = FinancialDataPurchaseDeferral;
module.exports.FinancialDataPurchaseDeferral = connect(
	state => {
        const step = state.accountPaymentPurchaseDeferralReducer.getIn(['steps', 1])
        const interests = step.getIn(['financingData', 'interests'])
        const quotaMonthly = step.getIn(['financingData', 'quotaMonthly'])
        const installmentList  = step.getIn(['financingData', 'installmentList'])
        const isFetching  = step.get('isFetching');
        return ({
            chosenDeferral: state.accountPaymentPurchaseDeferralReducer.getIn(['steps', 1, 'chosenDeferral']),
            immLavanda: state.cards.getIn(['credit','lavanda']),
            lavandaEnabled: state.flagBasedFeatures.get(LAVANDA),
            step: step,
            loading: !interests && !quotaMonthly && !installmentList,
            fetching: isFetching,
            isFetchingSpecificQuota: state.accountPaymentPurchaseDeferralReducer.getIn(['steps', 1, 'specificQuota', 'isFetching']),
            parameters: state.globalVariables.getIn(['variables', 'parameters']),
            threeMonthQuotaAmount: state.accountPaymentPurchaseDeferralReducer.getIn(['steps', 1, 'specificQuota', 'amount']),
	})},{
        getQuotaAmount,
        getQuotaData,
        setDeferralOption,
})(FinancialDataPurchaseDeferral);
